<mat-select
  [required]="to.required"
  [placeholder]="to.placeholder"
  [multiple]="to.isMultiSelect"
  [(value)]="selectedValue"
  [formlyAttributes]="field"
  [formControl]="formControl"
  (openedChange)="checkIfDropdownWasToggled($event)"
  (selectionChange)="onSelectedChange($event)"
>
  @if (listItem?.length) {
    <!----For hierarchical list ----------->
    @if (isHierarchicalList) {
      @for (currentItem of topHierarchicalListItem; track currentItem.value) {
        <div
          class="hierarchical-list-items"
          [class.hierarchical-list-items-background-color]="!to.isMultiSelect"
        >
          @if (to.isMultiSelect) {
          <mat-checkbox
            color="primary"
            (change)="
              getSelectedValueFromHierarchicalTopItems(currentItem, $event)
            "
            [checked]="currentItem?.checked"
          ></mat-checkbox>
          }
          <label>{{ currentItem.label | i18n_label }}</label>
        </div>
      }

      @if (topHierarchicalListItem?.length > 0) {
      <hr />
      }
    }
    <!----------------END------------------>
    <ng-template #recursiveMultiList let-listItem>
      @for (currentItem of listItem; track currentItem.value) {
        @if (!currentItem.items || currentItem.items?.length == 0 || to.listAnyLevelSelection) {
          <mat-option
            [value]="currentItem.value"
            [style.padding-left]="16 + currentItem.level * 16 + 'px'"
          >
            {{ currentItem.label | i18n_label }}
          </mat-option>
        }

        @if (currentItem.items?.length > 0) {
          @if (!to.listAnyLevelSelection) {
          <mat-optgroup>
            <label
              [style.padding-left]="currentItem.level * 16 + 'px'"
              >{{ currentItem.label | i18n_label }}</label
            >
          </mat-optgroup>
          }
          <ng-container
            *ngTemplateOutlet="
              recursiveMultiList;
              context: { $implicit: currentItem.items }
            "
          >
          </ng-container>
        }
      }
    </ng-template>

    <ng-container
      *ngTemplateOutlet="recursiveMultiList; context: { $implicit: listItem }"
    ></ng-container>
  } @else {
    <mat-option disabled>No options to select</mat-option>
  }
</mat-select>
